import {
    downFile,
    uploadAction,
    getFileAccessHttpUrl,
} from '@/api/manage';
import store from '@/store';
import { MessageBox } from 'element-ui';
import {
    getPolicyBase64,
    getSignature,
    randomString,
    getSuffix,
} from '@/utils/util';
import { getToken, removeToken } from '@/utils/auth';

export const publicMixin = {
    data() {
        return {
            // 默认显示第几页
            currentPage: 1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount: 0,
            // 个数选择器（可修改）
            pageSizes: [10, 20, 30, 40, 100, 200],
            // 默认每页显示的条数（可修改）
            PageSize: 10,
        };
    },
    computed: {
        tokenHeader() {
            let head = { Authorization: getToken() };
            return head;
        },
    },
    methods: {
        export(exportXlsUrl, obj, name) {
            let fileName = name;
            downFile(exportXlsUrl, obj).then((data) => {
                if (!data) {
                    this.$message.warning("文件下载失败");
                    return;
                }
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    window.navigator.msSaveBlob(
                        new Blob([data], { type: "application/vnd.ms-excel" }),
                        fileName + ".xls"
                    );
                } else {
                    let url = window.URL.createObjectURL(
                        new Blob([data], { type: "application/vnd.ms-excel" })
                    );
                    let link = document.createElement("a");
                    link.style.display = "none";
                    link.href = url;
                    link.setAttribute("download", fileName + ".xls");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                }
            });
        },
        uploadFile(file, path = "wali/", successc, failc) {
            return new Promise((resolve, reject) => {
                //获取policy
                const accessKeyId = "LTAI5tNqmSgYG2oTeimKK5PC";
                const accessKeySecret = "8fT0oXd2SH2EyDsCpyKelemxsWLNtF";
                const aliyunServerURL =
                    "https://waliminiapp.oss-cn-beijing.aliyuncs.com"; //OSS的访问域名
                const policyBase64 = getPolicyBase64();
                const signature = getSignature(policyBase64, accessKeySecret);

                let picName = randomString(10) + getSuffix(file.name);
                // let picName = data.file.name;
                let keyValue = path + picName;

                let formData = new FormData();
                formData.append("name", file.name); // 文件名称
                formData.append("key", keyValue); // 存储在oss的文件路径
                formData.append("OSSAccessKeyId", accessKeyId); // //accessKeyId
                formData.append("policy", policyBase64); // policy
                formData.append("Signature", signature); //签名
                formData.append("success_action_status", 200);
                formData.append("file", file, file.name); // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可

                uploadAction(aliyunServerURL, formData)
                    .then((res) => {
                        this.$message.success("上传成功");
                        resolve(aliyunServerURL + "/" + keyValue);
                    })
                    .catch((err) => {
                        this.$message.error("上传失败");
                        reject();
                    });
            });
        },
        /* 导入 */
        handleImportExcel(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                if (info.file.response.success) {
                    // this.$message.success(`${info.file.name} 文件上传成功`);
                    if (info.file.response.code === 201) {
                        let {
                            message,
                            result: { msg, fileUrl, fileName },
                        } = info.file.response;
                        let href = window._CONFIG['domianURL'] + fileUrl;
                        this.$message({
                            title: message,
                            message: (
                                <div>
                                    <span>{msg}</span>
                                    <br />
                                    <span>
                                        具体详情请{' '}
                                        <a href={href} target="_blank" download={fileName}>
                                            点击下载
                                        </a>{' '}
                                    </span>
                                </div>
                            ),
                        });
                    } else {
                        this.$message.success(
                            info.file.response.message || `${info.file.name} 文件上传成功`
                        );
                    }
                    this.loadData();
                } else {
                    this.$message.error(
                        `${info.file.name} ${info.file.response.message}.`
                    );
                }
            } else if (info.file.status === 'error') {
                if (info.file.response.status === 500) {
                    let data = info.file.response;
                    const token = getToken();
                    if (token && data.message.includes('Token失效')) {
                        MessageBox.alert('未授权，请重新登录', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning',
                            callback: (action) => {
                                store.dispatch('Logout').then(() => {
                                    removeToken();
                                    window.location.reload();
                                });
                            },
                        });
                    }
                } else {
                    this.$message.error(`文件上传失败: ${info.file.msg} `);
                }
            }
        },
        /* 图片预览 */
        getImgView(text) {
            if (text && text.indexOf(',') > 0) {
                text = text.substring(0, text.indexOf(','));
            }
            return getFileAccessHttpUrl(text);
        },
        /* 文件下载 */
        // update--autor:lvdandan-----date:20200630------for：修改下载文件方法名uploadFile改为downloadFile------
        downloadFile(text) {
            if (!text) {
                this.$message.warning('未知的文件');
                return;
            }
            if (text.indexOf(',') > 0) {
                text = text.substring(0, text.indexOf(','));
            }
            let url = getFileAccessHttpUrl(text);
            window.open(url);
        },
        //校验合法的银行卡号
        // luhnCheck(bankno) {
        //     var lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhn进行比较）
        //     var first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
        //     var newArr = new Array();
        //     for (var i = first15Num.length - 1; i > -1; i--) {
        //         //前15或18位倒序存进数组
        //         newArr.push(first15Num.substr(i, 1));
        //     }
        //     var arrJiShu = new Array(); //奇数位*2的积 <9
        //     var arrJiShu2 = new Array(); //奇数位*2的积 >9
        //     var arrOuShu = new Array(); //偶数位数组
        //     for (var j = 0; j < newArr.length; j++) {
        //         if ((j + 1) % 2 == 1) {
        //             //奇数位
        //             if (parseInt(newArr[j]) * 2 < 9)
        //                 arrJiShu.push(parseInt(newArr[j]) * 2);
        //             else arrJiShu2.push(parseInt(newArr[j]) * 2);
        //         } //偶数位
        //         else arrOuShu.push(newArr[j]);
        //     }
        //     var jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
        //     var jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
        //     for (var h = 0; h < arrJiShu2.length; h++) {
        //         jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
        //         jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
        //     }
        //     var sumJiShu = 0; //奇数位*2 < 9 的数组之和
        //     var sumOuShu = 0; //偶数位数组之和
        //     var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
        //     var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
        //     var sumTotal = 0;
        //     for (var m = 0; m < arrJiShu.length; m++) {
        //         sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
        //     }
        //     for (var n = 0; n < arrOuShu.length; n++) {
        //         sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
        //     }
        //     for (var p = 0; p < jishu_child1.length; p++) {
        //         sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
        //         sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
        //     }
        //     //计算总和
        //     sumTotal =
        //         parseInt(sumJiShu) +
        //         parseInt(sumOuShu) +
        //         parseInt(sumJiShuChild1) +
        //         parseInt(sumJiShuChild2);
        //     //计算luhn值
        //     var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
        //     var luhn = 10 - k;
        //     if (lastNum == luhn) {
        //         // $("#banknoInfo").html("luhn验证通过");
        //         return true;
        //     } else {
        //         // $("#banknoInfo").html("银行卡号必须符合luhn校验");
        //         return false;
        //     }
        // },
        // format(shijianchuo) {
        //     //shijianchuo是整数，否则要parseInt转换
        //     var time = new Date(shijianchuo);
        //     var y = time.getFullYear();
        //     var m = time.getMonth() + 1;
        //     var d = time.getDate();
        //     var h = time.getHours();
        //     var mm = time.getMinutes();
        //     var s = time.getSeconds();
        //     return y + "-" + this.add0(m) + "-" + this.add0(d);
        // },
        // add0(m) {
        //     return m < 10 ? "0" + m : m;
        // },
        handleSizeChange(val) {
            // 改变每页显示的条数
            this.PageSize = val;
            // 注意：在改变每页显示的条数时，要将页码显示到第一页
            this.currentPage = 1;
            this.getDataList();
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage = val;
            this.getDataList();
        },
    },
};
